import { Button, Text, makeStyles, tokens } from '@fluentui/react-components';
import { ArrowClockwise16Regular } from '@fluentui/react-icons';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles({
  root: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: tokens.spacingVerticalS,
    padding: tokens.spacingVerticalM,
    textAlign: 'center',
  },
  message: {
    color: tokens.colorPaletteRedForeground1,
  },
});

interface PanelErrorProps {
  onRetry: () => void;
}

// Shared, friendlier failure state for dashboard panels: a muted error icon, a
// short message, and a retry affordance instead of bare red text.
const PanelError = ({ onRetry }: PanelErrorProps) => {
  const styles = useStyles();
  const { t } = useTranslation();
  return (
    <div className={styles.root}>
      <Text size={200} className={styles.message}>
        {t('panelLoadFailed', "Couldn't load this data.")}
      </Text>
      <Button
        size="small"
        appearance="subtle"
        icon={<ArrowClockwise16Regular />}
        onClick={onRetry}
      >
        {t('retry', 'Retry')}
      </Button>
    </div>
  );
};

export default PanelError;
